<p-confirmDialog key="person" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<caass-personselector [AudienceID]="1"></caass-personselector>

<!--Stats and Option Selector-->
<div class="lock-to-top" style="background-color: #ffffff; margin-bottom: 25px; margin-top: 0">
	<div class="date-body">
		<div class="selector-body">
			<div class="selector-item" style="display: flex">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[disabled]="IsLoading() == true"
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						name="StartDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[disabled]="IsLoading() == true"
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						name="EndDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label style="margin: 0px">Show Voided Transactions</label>
				</div>

				<div style="margin-left: 10px">
					<input
						[disabled]="IsLoading() == true"
						class="form-control"
						style="margin: 0px; width: 20px; height: 20px"
						type="checkbox"
						[(ngModel)]="ShowVoid"
						(ngModelChange)="onVoidChange($event)"
					/>
				</div>
			</div>
		</div>
	</div>

	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<div class="total-body">
		<div class="StatsGrid" style="margin-left: 20px; margin-right: 20px; padding-bottom: 5px">
			<div>
				<label>Current Balance:</label>
				<label *ngIf="StatLoading == false" class="statcount">{{ CurrentBalance }}</label>
			</div>
		</div>
	</div>
</div>

<!--Person Table-->
<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddPoint()">Add Point</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onRedeemPoint()">
							Redeem Point
						</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onVoid()">Void Transaction</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
						<button
							*ngIf="IsSU() == true"
							[disabled]="IsLoading() == true || IsSU() == false"
							class="btn btn-danger"
							style="margin-left: 5px"
							(click)="onDelete()"
						>
							Delete (SU Only)
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstPointsTransaction"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedPointsTransaction"
						dataKey="PointsTransactionID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--MeritDT-->
								<th>
									<!-- <p-columnFilter type="text" field="MeritDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--PointsTransactionTypeDesc-->
								<th>
									<p-columnFilter id="PointsTransactionTypeDesc" field="PointsTransactionTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPointsTransactionTypeDesc
												[ngModel]="value"
												[options]="lstPointsTransactionTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PointsItemDesc-->
								<th>
									<p-columnFilter id="PointsItemDesc" field="PointsItemDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPointsItemDesc
												[ngModel]="value"
												[options]="lstPointsItemDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PointsItemValue-->
								<th></th>

								<!--IsVoidDesc-->
								<th *ngIf="ShowVoid == true">
									<p-columnFilter id="IsVoidDesc" field="IsVoidDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterIsVoidDesc
												[ngModel]="value"
												[options]="lstIsVoidDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PartOfGroupDesc-->
								<!-- <th>
									<p-columnFilter id="PartOfGroupDesc" field="PartOfGroupDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown #filterPartOfGroupDesc [ngModel]="value" [options]="lstPartOfGroupDesc" (onChange)="filter($event.value)"
												placeholder="Any" [showClear]="true">
												<ng-template let-value pTemplate="item">
													<span>{{value}}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th> -->

								<!--GroupName-->
								<th>
									<p-columnFilter id="GroupName" field="GroupName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterGroupName
												[ngModel]="value"
												[options]="lstGroupName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="TransactionDT">Date/Time<p-sortIcon field="TransactionDT"></p-sortIcon></th>
								<th pSortableColumn="PointsTransactionTypeDesc">Transaction Type<p-sortIcon field="PointsTransactionTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="PointsItemDesc">Point<p-sortIcon field="PointsItemDesc"></p-sortIcon></th>
								<th pSortableColumn="PointsItemValue">Point Value<p-sortIcon field="PointsItemValue"></p-sortIcon></th>
								<th *ngIf="ShowVoid == true" pSortableColumn="IsVoid">Voided?<p-sortIcon field="IsVoid"></p-sortIcon></th>
								<th pSortableColumn="GroupName">Added for Group<p-sortIcon field="GroupName"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-MeritPerson>
							<tr [pSelectableRow]="MeritPerson" (dblclick)="onRowDblClick(MeritPerson)">
								<td
									*ngFor="let col of cols"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="MeritPerson.IsVoid == true ? 'Red' : 'Black'"
								>
									{{ MeritPerson[col.field] }}
								</td>

								<td
									*ngIf="ShowVoid == true"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="MeritPerson.IsVoid == true ? 'Red' : 'Black'"
								>
									{{ MeritPerson["IsVoidDesc"] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="MeritPerson.PartOfGroup == false ? 'Red' : 'Black'"
								>
									{{ MeritPerson.GroupName }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div *ngIf="isProcessing" class="TopMargin">
					<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
